export default function CredibilityBar() {
  return (
    <section className="bg-light-warm-gray py-12">
      <div className="max-w-[1200px] mx-auto px-20">
        <div className="grid grid-cols-3 gap-16">
          {/* Column 1 */}
          <div className="flex flex-col items-center text-center">
            <div className="w-8 h-8 flex items-center justify-center mb-3">
              <i className="ri-message-2-line text-[32px] text-muted-teal" style={{ strokeWidth: '0.5px' }}></i>
            </div>
            <p className="font-sans text-base leading-relaxed text-charcoal max-w-[280px]">
              Built for real business conversations, client calls, and presentations
            </p>
          </div>

          {/* Divider */}
          <div className="relative flex justify-center">
            <div className="absolute left-0 top-1/2 -translate-y-1/2 w-px h-[60%] bg-border-gray"></div>
            
            {/* Column 2 */}
            <div className="flex flex-col items-center text-center">
              <div className="w-8 h-8 flex items-center justify-center mb-3">
                <i className="ri-refresh-line text-[32px] text-warm-amber" style={{ strokeWidth: '0.5px' }}></i>
              </div>
              <p className="font-sans text-base leading-relaxed text-charcoal max-w-[280px]">
                Practice-driven approach: listen, refine, repeat, and lock it in
              </p>
            </div>

            <div className="absolute right-0 top-1/2 -translate-y-1/2 w-px h-[60%] bg-border-gray"></div>
          </div>

          {/* Column 3 */}
          <div className="flex flex-col items-center text-center">
            <div className="w-8 h-8 flex items-center justify-center mb-3">
              <i className="ri-calendar-check-line text-[32px] text-soft-coral" style={{ strokeWidth: '0.5px' }}></i>
            </div>
            <p className="font-sans text-base leading-relaxed text-charcoal max-w-[280px]">
              Self-paced lessons plus weekly live group sessions with your coach
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
